import React, { useEffect, useState } from 'react'
import { MdMoreTime } from "react-icons/md";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { IoVideocamOutline } from "react-icons/io5";
import { LiaRupeeSignSolid } from "react-icons/lia";
import Select from 'react-select';
import { useNavigate, useLocation , useParams } from "react-router-dom";
import './AstrologerAnalytics.css'
import { API_END_POINT, TOKEN } from '../../../constant';
import Loader from '../../Loader/Loader';
import axios from 'axios';
import { toast } from 'react-toastify';

function AstroAna() {
      const navigate = useNavigate();
    
    const [loading, setLoading] = useState(false)
    const [astrologersData, setAstrologersData] = useState([])

    const { id } = useParams();
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();
    const years = []
    for (let y = currentYear - 10; y <= currentYear + 10; y++) {
        years.push({ value: y, label: y.toString() })
    }
    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
    ];

    const [selectedMonth, setSelectedMonth] = useState(
        months.find((month) => month.value === currentMonth)
    )

    const [selectedYear, setSelectedYear] = useState(
        years.find((year) => year.value === currentYear)
    )

    useEffect(() => {
        console.log("this is selectedyear--->>", selectedYear)
        console.log("this is selectedMonth--->>>", selectedMonth)
        getAstrologerAnalytics();
    }, [selectedMonth, selectedYear])

    const getAstrologerAnalytics = async () => {
        setLoading(true)
        const getAstrologersAnalyticsUrl = `${API_END_POINT}astro-analytics/fetch-data`
        const getAstrologersAnalyticsHeaders = {
            'Authorization': `Bearer ${TOKEN}`
        }
        try {
            const astrologersAnalyticsResponse = await axios.get(getAstrologersAnalyticsUrl, {
                headers: getAstrologersAnalyticsHeaders,
                params: {
                    month: selectedMonth.value,
                    year: selectedYear.value,
                    astrologerId: id
                }
            })
            setAstrologersData(astrologersAnalyticsResponse.data.data)

        } catch (error) {
            toast.error("failed to fetch astrologers analytics data")
            console.error("AstrologersAna.jsx --->>> getAstrologerAnalytics() --->>>", error)
        } finally {
            setLoading(false)
        }
    }


    return (
        <main className='main'>
            {!loading ? (
                <div>
                    <h3>Astrologer Analytics</h3>
                    <div className='filter-container'>
                        <Select
                            options={months}
                            value={selectedMonth}
                            onChange={(option) => (setSelectedMonth(option))}
                            placeholder="Select Month"
                            styles={{ container: (base) => ({ ...base, flex: 1 }) }}
                        />
                        <Select
                            options={years}
                            value={selectedYear}
                            onChange={(option) => (setSelectedYear(option))}
                            placeholder="Select Year"
                            styles={{ container: (base) => ({ ...base, flex: 1 }) }}
                        />
                    </div>
                    {astrologersData.map((astrologer) => {
                        return (
                            <div className='analytics-container'>
                                <div >
                                    <h5>Astrologer Name: {astrologer.name} </h5>
                                </div>

                                <div className='cards-wrapper'>
                                    <div className='analytics-card'>
                                        <div>
                                            <MdMoreTime style={{ fontSize: '50px' }} />
                                        </div>
                                        <div> {astrologer.monthlySummaries[0].totalTimeMinutes} <span style={{fontSize:'14px'}} >min</span> /   {astrologer.monthlySummaries[0].chat.amountInr + astrologer.monthlySummaries[0].call.amountInr} <LiaRupeeSignSolid style={{ alignItems: 'end', fontWeight: '500' }} /> </div>
                                    </div>

                                    <div className='analytics-card'>
                                        <div>
                                            <IoChatbubbleEllipsesOutline style={{ fontSize: '50px' }} />
                                        </div>
                                        <div> {astrologer.monthlySummaries[0].chat.timeMinutes} <span style={{fontSize:'14px'}} >min</span> / {astrologer.monthlySummaries[0].chat.amountInr} <LiaRupeeSignSolid style={{ alignItems: 'end', fontWeight: '500' }} /> </div>
                                    </div>

                                    <div className='analytics-card'>
                                        <div> 
                                            <IoVideocamOutline style={{ fontSize: '50px' }} />
                                        </div>
                                        <div>{astrologer.monthlySummaries[0].call.timeMinutes} <span style={{fontSize:'14px'}} >min</span> / {astrologer.monthlySummaries[0].call.amountInr} <LiaRupeeSignSolid style={{ alignItems: 'end', fontWeight: '500' }} /> </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div>
                    <Loader />
                </div>
            )}
        </main>
    )
}

export default AstroAna
